import { createContext } from 'react';

const FormContext = createContext<Record<string, unknown> | null>(null);
const FormMethodsContext = createContext<Record<string, unknown> | null>(null);

export { FormContext, FormMethodsContext };
